import { defineNuxtPlugin } from '#app/nuxt'
import { LazyBlockCarouselAuto, LazyBlockCarouselHorizontal, LazyBlockCarouselReveal, LazyBlockFormNewsletter, LazyBlock, LazyBlockMarquee, LazyBlockMediaCouple, LazyBlockMediaFullframe, LazyBlockMediaMasonry, LazyBlockMediaMosaic, LazyBlockMediaVimeo, LazyBlockSocialInstagram, LazyBlockTextCta, LazyBlockTextMediaCouple, LazyBlockTextMediaHeader, LazyBlockTextMediaParallax, LazyBlockTextParagraph, LazyBlockTextProductFamily, LazyBlockTextQuote, LazyBlockTextRich, LazyBlockTextTypography } from '#components'
const lazyGlobalComponents = [
  ["BlockCarouselAuto", LazyBlockCarouselAuto],
["BlockCarouselHorizontal", LazyBlockCarouselHorizontal],
["BlockCarouselReveal", LazyBlockCarouselReveal],
["BlockFormNewsletter", LazyBlockFormNewsletter],
["Block", LazyBlock],
["BlockMarquee", LazyBlockMarquee],
["BlockMediaCouple", LazyBlockMediaCouple],
["BlockMediaFullframe", LazyBlockMediaFullframe],
["BlockMediaMasonry", LazyBlockMediaMasonry],
["BlockMediaMosaic", LazyBlockMediaMosaic],
["BlockMediaVimeo", LazyBlockMediaVimeo],
["BlockSocialInstagram", LazyBlockSocialInstagram],
["BlockTextCta", LazyBlockTextCta],
["BlockTextMediaCouple", LazyBlockTextMediaCouple],
["BlockTextMediaHeader", LazyBlockTextMediaHeader],
["BlockTextMediaParallax", LazyBlockTextMediaParallax],
["BlockTextParagraph", LazyBlockTextParagraph],
["BlockTextProductFamily", LazyBlockTextProductFamily],
["BlockTextQuote", LazyBlockTextQuote],
["BlockTextRich", LazyBlockTextRich],
["BlockTextTypography", LazyBlockTextTypography],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
